// extracted by mini-css-extract-plugin
export default {"successWindow":"successWindow_successWindow__HM9+o","container":"successWindow_container__tKKCI","successWindowOpened":"successWindow_successWindowOpened__-MOpV"};